/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

export class EnumUtilities {
  static isValidEnumValue<TEnum extends Record<string | number, string | number>>(
    enumValue: string | number,
    enumType: TEnum
  ): enumValue is TEnum[Extract<keyof TEnum, string>] {
    if (typeof enumValue === 'number') {
      // For numeric enums, TypeScript creates reverse mappings (number -> string key).
      // e.g., if `MyEnum.Foo = 0`, then `MyEnum[0]` is "Foo".
      // If `enumValue` is a valid numeric member, `enumType[enumValue]` will exist.
      // For string enums, `enumType[numberValue]` will usually be undefined unless numeric keys are used.
      return enumType[enumValue] !== undefined;
    }

    if (typeof enumValue === 'string') {
      const isKey = enumType.hasOwnProperty(enumValue);
      const isValue = Object.values(enumType).includes(enumValue);

      return isKey || isValue;
    }

    return false;
  }
}
